<div
  class="predisposition-card"
  role="button"
  tabindex="0"
  (click)="clickOnRisk(predisposition.risk)"
  (keydown.enter)="clickOnRisk(predisposition.risk)"
  (keydown.space)="clickOnRisk(predisposition.risk)"
>
  <div class="predisposition-header">
    <div class="predisposition-left">
      <h3 class="predisposition-title">{{ predisposition.title }}</h3>
    </div>

    <div class="predisposition-right">
      <div class="predisposition-progress">
        <div class="predisposition-dots">
          <span class="dot" *ngFor="let _ of [].constructor(progress.total); let i = index" [class.active]="i < progress.done"> </span>
        </div>

        <span class="predisposition-progress-label">
          {{
            progress.isComplete
              ? ("page.home.predispositions.progress.complete" | translate)
              : ("page.home.predispositions.progress.done" | translate: { done: progress.done, total: progress.total })
          }}
        </span>
      </div>
    </div>
  </div>

  <div class="predisposition-inner-grid">
    <app-sr-predisposition
      *ngFor="let sr of predisposition.serviceRequests"
      [srpredisposition]="sr"
      [riskId]="predisposition.risk"
      (click)="$event.stopPropagation()"
    ></app-sr-predisposition>

    <app-qr-predisposition
      *ngFor="let qr of predisposition.questionnaires"
      [qrpredisposition]="qr"
      [riskId]="predisposition.risk"
      (click)="$event.stopPropagation()"
    ></app-qr-predisposition>
  </div>
</div>
